<template>
  <v-row
    class="landing-wrapper"
    :style="{ backgroundImage: 'url(' + responsiveImage + ')' }"
  >
    <v-col>
      <v-row class="app-container--width-max mx-auto mt-0">
        <v-col cols="12" lg="6">
          <div class="left-panel-wrapper">
            <h1 class="text-uppercase">{{ title }}</h1>
            <div class="text--underline"></div>
            <ul>
              <li
                class="font-16 align-start d-flex"
                v-for="(benefit, index) in listBenefits"
                :key="index"
              >
                <v-icon color="#1d8649">mdi-check-circle</v-icon
                >{{ benefit?.text }}
              </li>
            </ul>
            <v-btn
              :ripple="false"
              depressed
              rounded
              color="mustard"
              x-large
              class="font-weight-bold font-18 text-uppercase width-full mt-9"
              @click="$emit('openCreateLLQuoteDialog')"
              aria-label="Get a new quote"
            >
              Get a new quote
            </v-btn>
            <div class="text-center">
              <a
                class="text-decoration-underline text-uppercase font-weight-bold"
                @click="$emit('openRetrieveQuoteDialog')"
                aria-label="Retrieve a quote"
                >Retrieve a quote</a
              >
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" align-self="end">
          <div class="d-flex right-panel-wrapper">
            <a
              class="defaqto"
              title="defaqto compare tool"
              href="https://www.paymentshield.co.uk/advisers/tools-and-support/defaqto-compare-for-clients"
              target="_blank"
            >
              <v-img
                :width="'134'"
                :src="defaqtoImageUrl"
                transition="scale-transition"
                :max-width="'134'"
                alt="Defaqto 5-star Expert Rated"
                class="img"
              />
            </a>
            <span
              class="trustpilot-widget"
              data-locale="en-US"
              data-template-id="53aa8807dec7e10d38f59f32"
              data-businessunit-id="58d39bef0000ff00059f0b6a"
              :data-style-height="'77px'"
              :data-style-width="'118px'"
              data-theme="dark"
            >
              <a
                href="https://www.trustpilot.com/review/paymentshield.co.uk"
                target="_blank"
                rel="noopener"
                >Trustpilot</a
              >
            </span>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { LIST_BENEFITS } from "@/constants/d2c-landing-page.constants";
export default {
  name: "LandingPageBanner",
  props: {
    title: {
      type: String,
      default: "Home insurance",
    },
    defaqtoImageUrl: {
      type: String,
      default: require("@/assets/images/defaqto/standard.svg"),
    },
    bgImageMobileUrl: {
      type: String,
      default: require("@/assets/images/hero.jpeg"),
    },
    bgImageDesktopUrl: {
      type: String,
      default: require("@/assets/images/hero.jpeg"),
    },
    listBenefits: {
      type: Array,
      default: () => LIST_BENEFITS,
    },
  },
  computed: {
    responsiveImage() {
      const { xs, sm } = this.$vuetify.breakpoint;
      if (xs || sm) return this.bgImageMobileUrl;
      return this.bgImageDesktopUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.landing-wrapper {
  background-position: 50% 75%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 480px;
  .app-container--width-max {
    max-width: 1096px !important;
  }
  .left-panel-wrapper {
    color: #fff;
    padding: 41px 44px 33px;
    margin-top: 18px;
    margin-left: -10px;
    max-width: 635px;
    width: 635px;
    border-radius: 10px;
    background-color: rgba(39, 39, 39, 0.9);
    h1 {
      font-weight: 800;
      font-size: 40px;
    }
    ul {
      list-style-type: none;
      padding-left: 7px;
      margin-top: 11px;
      li {
        padding-top: 14px;
        position: relative;
        .v-icon {
          margin-right: 12px;
        }
        &::before {
          height: 15px;
          width: 15px;
          border-radius: 15px;
          background: #fff;
          content: "";
          left: 4px;
          top: 17px;
          display: inline-block;
          position: absolute;
        }
      }
    }
    .text--underline {
      max-width: 545px;
      height: 2px;
      background: #fff;
      margin-top: -8px;
    }
    .v-btn {
      min-width: auto;
      margin-top: 36px;
    }
    a {
      color: #fff;
      padding-top: 7px;
      display: inline-block;
    }
    .icon-check {
      margin-right: 12px;
    }
  }
  .right-panel-wrapper {
    padding-left: 193px;
    .defaqto {
      margin-right: 30px;
    }
    .trustpilot-widget {
      background-color: #262625;
      border: 1px solid #000;
      border-radius: 4px;
      padding: 3px 14px 3px 14px;
    }
  }
}

@media screen and (max-width: $grid-breakpoints-lg - 1) {
  .landing-wrapper {
    height: auto;
    margin: 0;
    background-position: 100% 0%;
    background-size: cover;
    .left-panel-wrapper {
      width: 100%;
      max-width: 413px;
      margin: 16px auto 0;
      padding: 38px 20px 38px 20px;
      .text--underline {
        display: none;
      }
      h1 {
        font-size: 26px;
        text-decoration: underline;
      }
      ul {
        padding-left: 0;
        margin-top: 9px;
        li {
          padding-top: 21px;

          &::before {
            top: 25px;
            left: 5px;
          }
        }
      }
      .v-btn {
        min-width: 100%;
      }
    }
    .right-panel-wrapper {
      padding-left: 0;
      align-items: center;
      justify-content: center;
      .defaqto {
        margin-right: 24px;
        max-width: 173px;
      }
    }
    .app-container--width-max {
      padding: 0 !important;
    }
  }
}

@media screen and (min-width: $grid-breakpoints-shd) {
  .landing-wrapper {
    background-position: 0% 75%;
  }
}

// keep line at small screen
@media screen and (max-width: $grid-breakpoints-xs + 84) {
  .landing-wrapper {
    .left-panel-wrapper {
      h1 {
        font-size: 22px;
      }
    }
  }
}
</style>
